import { DateFormatEnum, TemperatureUnitEnum } from "requests";
import useAuth from "./useAuth";

const useOrganizationSettings = () => {
  const [{ user }] = useAuth();

  const dateFormats = {
    [DateFormatEnum.MmDdYyyyWithSlash]: "MM/dd/yyyy",
    [DateFormatEnum.MmDdYyyyWithSpace]: "MMM dd, yyyy",
    [DateFormatEnum.DdMmYyyyWithSlash]: "dd/MM/yyyy"
  };

  const temperatureUnitSymbols = {
    [TemperatureUnitEnum.Fahrenheit]: "ºF",
    [TemperatureUnitEnum.Celsius]: "ºC"
  };

  return {
    dateFormat:
      dateFormats[
        user.organization?.organizationSetting?.dateFormat ||
          DateFormatEnum.MmDdYyyyWithSlash
      ],
    temperatureUnit:
      user.organization?.organizationSetting?.temperatureUnit ||
      TemperatureUnitEnum.Fahrenheit,
    temperatureUnitSymbol:
      temperatureUnitSymbols[
        user.organization?.organizationSetting?.temperatureUnit ||
          TemperatureUnitEnum.Fahrenheit
      ]
  };
};

export default useOrganizationSettings;
